import { SelectOption } from './types';

export const getSelectOptions = <T extends string | number>(
  options: (T | SelectOption<T>)[]
) => {
  return options.map((option) => {
    if (typeof option === 'object') return option;

    return {
      label: `${option}`,
      value: option,
    };
  });
};
